export class EventInfo {
  topic: string;
  eventName: string;
  application: string;
}
